"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_RECENT_EXTENSION_PROCESS_STATUS = exports.EXTEND_PRODUCT_ACCESS_B2B = exports.EXTENSION_RAISE_CREDIT_MEMO = exports.EXTEND_PRODUCT_ACCESS = exports.PROCESS_BULK_RENEWAL = exports.DOWNLOAD_BULK_RENEWAL_REPORT = exports.GET_RECENT_DOWNLOAD_REPORT = exports.GET_RECENT_BULK_RENEWAL_TRANSACTION = exports.GET_BULK_RENEWAL_TRANSACTION_HISTORY = exports.GENERATE_BULK_RENEWAL_REPORT = exports.UPDATE_MEMBERSHIP_TERMINATION_STATUS = exports.CANCEL_MEMBERSHIP_ORDER = exports.CANCEL_AND_MOVE = exports.REFUND = exports.REMOVE_CLIENT_ADMIN = exports.GET_ASSIGNED_APPLICATIONS = exports.GET_ASSIGNED_ORDERS = exports.GET_B2B_ORDER_PREVIEW = exports.CANCEL_INVOICE = exports.GET_ORGANIZATION_ZUORA_ACCOUNT_ID = exports.GET_ORGANIZATION_CURRENCY = exports.GET_SUBSCRIPTIONS = exports.GET_INVOICE_ITEMS = exports.GET_ADMIN_INVOICE_FILE = exports.PAY_INVOICES = exports.SEARCH_INVOICES_BY_INVOICE_NUMBER = exports.SEARCH_INVOICES_BY_UID = exports.ASSIGN_ADMIN = exports.REMOVE_SWAP_ADMINS = exports.GET_ORGANIZATION_ORDERS = exports.SEARCH_PRODUCT = exports.CLONE_VARIANT_BY_SKU = exports.GET_ORGANIZATION_BY_ACCOUNT_ID = exports.GET_ORGANIZATION_BY_ACCOUNT_NUMBER = exports.ORGANIZATION_ADMIN_USERS_BY_ROLE = exports.ORGANIZATION_ADMIN_USERS = exports.ORGANIZATION_USERS = exports.CANCEL_ORDER = exports.CREATE_B2B_ORDER = exports.DEPROVISION = exports.CANCEL_PREVIEW_ORDER = exports.SET_LEGACY_IMPERSONATION = exports.GET_SEAT_MANAGEMENT_INVITE = exports.GET_ADMIN_IMPERSONATE = exports.SEARCH_USER = exports.GET_ADMIN_FEATURE_TOGGLES = void 0;
exports.GET_ADMIN_FEATURE_TOGGLES = `
	{
		adminFeatureToggles
	}
`;
exports.SEARCH_USER = `
  query searchUser($accountNumber: String!, $email: String!) {
    searchUser(id:$accountNumber, email: $email)
  }
`;
exports.GET_ADMIN_IMPERSONATE = `
	query impersonate($oktaId: String!, $country: String) {
		impersonate(oktaId: $oktaId, country: $country)
	}
`;
exports.GET_SEAT_MANAGEMENT_INVITE = `
  query getSeatManagementInvite($orderNumber: String!) {
    getSeatManagementInvite(orderNumber: $orderNumber)
  }
`;
exports.SET_LEGACY_IMPERSONATION = `
  mutation ($targetEmail: String!){
    setLegacyImpersonation(targetEmail: $targetEmail){
      success
    }
  }
`;
exports.CANCEL_PREVIEW_ORDER = `
	mutation previewCancelOrder(
    $firmAccountId: String,
    $ratePlanId: String,
    $subscriptionStartDate: String,
    $subscriptionEndDate: String,
    $subscriptionNumber: String,
    $isOnlyProductOnSubscription: Boolean!,
    $shouldCancelFromStartDate: Boolean!,
    $isAutoRenewable: Boolean!,
    $previewThruStartDate: Boolean,
    $isB2B: Boolean,
    $refundAction: String,
    $seatNumber: Int,
    $availableSeats: Int,
    $assignedSeats: Int,
    $productSku: String,
    $discountedPrice: Float,
  ) {
		previewCancelOrder(
      firmAccountId: $firmAccountId,
      ratePlanId: $ratePlanId,
      subscriptionStartDate: $subscriptionStartDate,
      subscriptionEndDate: $subscriptionEndDate,
      subscriptionNumber: $subscriptionNumber,
      isOnlyProductOnSubscription: $isOnlyProductOnSubscription,
      shouldCancelFromStartDate: $shouldCancelFromStartDate,
      isAutoRenewable: $isAutoRenewable,
      previewThruStartDate: $previewThruStartDate,
      isB2B: $isB2B,
      refundAction: $refundAction,
      seatNumber: $seatNumber,
      availableSeats: $availableSeats,
      assignedSeats: $assignedSeats,
      productSku: $productSku,
      discountedPrice: $discountedPrice
    ) {
      pricePaid,
      discountApplied,
      refundAmount,
      taxAmount
    }
	}
`;
exports.DEPROVISION = `
  mutation deprovision($orderId: String!, $skusForItemsBeingDeprovisioned: [String!], $isTerminated: Boolean, $isNonMember: Boolean) {
    deprovision(orderId: $orderId, skusForItemsBeingDeprovisioned: $skusForItemsBeingDeprovisioned, isTerminated: $isTerminated, isNonMember: $isNonMember)
  }
`;
exports.CREATE_B2B_ORDER = `
	mutation createB2BOrder(
    $accountId: String!,
    $legalEntity: String,
    $cart: JSON!,
    $shippingAddress: JSON!,
    $billingAddress: JSON!,
    $invoiceDetails: JSON!,
    $isFromBatchProcess: Boolean
  ) {
		createB2BOrder(
      accountId: $accountId,
      legalEntity: $legalEntity,
      cart: $cart,
      shippingAddress: $shippingAddress,
      billingAddress: $billingAddress,
      invoiceDetails: $invoiceDetails,
      isFromBatchProcess: $isFromBatchProcess
    ) {orderNumber}
	}
`;
exports.CANCEL_ORDER = `
	mutation cancelOrder(
    $ratePlanId: String,
    $subscriptionStartDate: String,
    $subscriptionNumber: String,
    $isOnlyProductOnSubscription: Boolean!
    $isAutoRenewable: Boolean!,
    $subscriptionEndDate: String,
    $shouldCancelFromStartDate: Boolean,
    $amount: String,
    $sku: String,
    $zuoraProductId: String,
    $firmAccountId: String,
    $orderProductId: String,
    $cancelledQuantity: String,
    $isEndOfLastInvoicePeriod: Boolean!,
    $isB2B: Boolean,
    $refundAction: String,
    $seatNumber: Int,
    $availableSeats: Int,
    $assignedSeats: Int,
    $discountedPrice: Float,
    $runBilling: Boolean,

  ) {
		cancelOrder(
      ratePlanId: $ratePlanId,
      subscriptionStartDate: $subscriptionStartDate
      subscriptionNumber: $subscriptionNumber
      isOnlyProductOnSubscription: $isOnlyProductOnSubscription
      isAutoRenewable: $isAutoRenewable
      subscriptionEndDate: $subscriptionEndDate
      shouldCancelFromStartDate: $shouldCancelFromStartDate
      amount: $amount
      sku: $sku
      zuoraProductId: $zuoraProductId
      firmAccountId: $firmAccountId
      orderProductId: $orderProductId
      cancelledQuantity: $cancelledQuantity
      isEndOfLastInvoicePeriod: $isEndOfLastInvoicePeriod
      isB2B: $isB2B
      refundAction: $refundAction
      seatNumber: $seatNumber
      availableSeats: $availableSeats
      assignedSeats: $assignedSeats,
      discountedPrice: $discountedPrice
      runBilling: $runBilling
      )
	}
`;
exports.ORGANIZATION_USERS = `
	query organizationUsers($id: String!) {
		organizationUsers(id: $id) {
      id
      firstName
      lastName
      email
      phone
    }
	}
`;
exports.ORGANIZATION_ADMIN_USERS = `
	query organizationAdminUsers($id: String!, $isFromBatchProcess: Boolean) {
		organizationAdminUsers(id: $id, isFromBatchProcess: $isFromBatchProcess) {
      id
      firstName
      lastName
      aicpaId
      email
      contactId
      adminType
      phone
      hasAssignedMembership
      firmMembershipType
      firmMembershipTypes
    }
	}
`;
exports.ORGANIZATION_ADMIN_USERS_BY_ROLE = `
	query organizationAdminUsersByRole($id: String!, $role: String!) {
		organizationAdminUsersByRole(id: $id, role: $role) {
      id
      firstName
      lastName
      aicpaId
      email
      adminType
      phone
    }
	}
`;
exports.GET_ORGANIZATION_BY_ACCOUNT_NUMBER = `
  query organization($accountNumber: String, $isFromBatchProcess: Boolean) {
    organization(accountNumber: $accountNumber, isFromBatchProcess: $isFromBatchProcess) {
            id
        }
  }
`;
exports.GET_ORGANIZATION_BY_ACCOUNT_ID = `
  query organization($accountId: String) {
    organization(accountId: $accountId) {
            name
            creditHoldStatus
            hasAICPAUid
            billingAddress {
              addressLine1
              city
              state
              zipCode
              country
            }
            parentId
            currentParentId
            shippingAddress {
              addressLine1
              city
              state
              zipCode
              country
            }
            type
            phone
            numCPA
            taxExemption
        }
      }
`;
exports.CLONE_VARIANT_BY_SKU = `
  mutation cloneVariantBySku($sku: String!) {
    cloneVariantBySku(sku: $sku)
  }
`;
exports.SEARCH_PRODUCT = `
  query searchProduct($sku: String!, $isFromBatchProcess: Boolean) {
    searchProduct(sku: $sku, isFromBatchProcess: $isFromBatchProcess)
  }
`;
exports.GET_ORGANIZATION_ORDERS = `
  query organizationOrders($accountId: String!, $accountNumber: String, $legalEntity: String) {
    organizationOrders(accountId: $accountId, accountNumber: $accountNumber, legalEntity: $legalEntity) {
      orderNumber
      dateCreated
      status
      totalAmountIncTax
      clientAdmin
    }
  }
`;
exports.REMOVE_SWAP_ADMINS = `
  mutation removeSwapClientAdmin($accountId: String!, $adminToRemoveId: String!, $adminToSwapEmail: String!, $firmMembershipTypeToRemove: String, $firmMembershipTypes: [String]) {
    removeSwapClientAdmin(accountId: $accountId, adminToRemoveId: $adminToRemoveId, adminToSwapEmail: $adminToSwapEmail, firmMembershipTypeToRemove: $firmMembershipTypeToRemove, firmMembershipTypes: $firmMembershipTypes)
  }
`;
exports.ASSIGN_ADMIN = `
 mutation assignAdmin($accountId: String!, $email: String!, $aicpaId: String) {
  assignAdmin(accountId: $accountId, email: $email, aicpaId: $aicpaId) {
    isAdminAssigned
  }
}
`;
exports.SEARCH_INVOICES_BY_UID = `
  query searchInvoicesByUid($uid: String!, $legalEntity: String!) {
    searchInvoicesByUid(uid: $uid, legalEntity: $legalEntity) {
      id
      invoiceDate
      dueDate
      amount
      balance
      invoiceNumber
      status
      accountId
      orderNumber
      currency
    }
  }
`;
exports.SEARCH_INVOICES_BY_INVOICE_NUMBER = `
  query searchInvoicesByInvoiceNumber($invoiceNumber: String!) {
    searchInvoicesByInvoiceNumber(invoiceNumber: $invoiceNumber) {
      id
      invoiceDate
      dueDate
      amount
      balance
      invoiceNumber
      status
      accountId
      orderNumber
      currency
      legalEntity
    }
  }
`;
exports.PAY_INVOICES = `
  mutation payInvoices($paymentMethodId: String!, $totalAmount: Float!, $accountId: String!, $invoices: [InvoiceInput!], $invoiceEntity: String, $paymentMethod: String, $isPartialPayment: Boolean){
    payInvoices(paymentMethodId: $paymentMethodId, totalAmount: $totalAmount, accountId: $accountId, invoices: $invoices, invoiceEntity: $invoiceEntity, paymentMethod: $paymentMethod, isPartialPayment: $isPartialPayment){
      status
      totalAmountPaid
      totalBalance
      paymentDate
      success
      invoiceNumbers
    }
  }
`;
exports.GET_ADMIN_INVOICE_FILE = `
  query getAdminInvoiceFile($invoiceId: String) {
    getAdminInvoiceFile(invoiceId: $invoiceId)
  }
`;
exports.GET_INVOICE_ITEMS = `
  query getInvoiceItems($invoiceId: String, $legalEntity: String, $offset: Int, $limit: Int) {
    getInvoiceItems(invoiceId: $invoiceId, legalEntity: $legalEntity, offset: $offset, limit: $limit){
      list {
        id
        subscriptionName
        subscriptionId
        serviceStartDate
        serviceEndDate
        balance
        chargeAmount
        chargeDescription
        chargeName
        chargeId
        description
        productName
        quantity
        taxAmount
        unitOfMeasure
        unitPrice
        appliedToItemId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionOwner
      }
      totalCount
    }
  }
`;
exports.GET_SUBSCRIPTIONS = `
  query getSubscriptionsFromInvoiceId($invoiceId: String, $legalEntity: String, $offset: Int, $limit: Int) {
    getSubscriptionsFromInvoiceId(invoiceId: $invoiceId, legalEntity: $legalEntity, offset: $offset, limit: $limit){
      list {
        subscriptionName
        status
        chargeAmount
      }
      totalCount
    }
  }
`;
exports.GET_ORGANIZATION_CURRENCY = `
query getOrganizationCurrency($accountNumber: String! $legalEntity: String!) {
    getOrganizationCurrency(accountNumber: $accountNumber, legalEntity: $legalEntity) {
      accountId
      currency
      originalOrderDate
      entity
    }
  }
`;
exports.GET_ORGANIZATION_ZUORA_ACCOUNT_ID = `
query getOrganizationZuoraAccountId($accountNumber: String!) {
  getOrganizationZuoraAccountId(accountNumber: $accountNumber)
  }
`;
exports.CANCEL_INVOICE = `
  mutation ($entityType:String!, $invoiceId: String!, $subscriptionIds: [String]){
    cancelInvoice(entityType:$entityType, invoiceId: $invoiceId, subscriptionIds: $subscriptionIds)
  }
`;
exports.GET_B2B_ORDER_PREVIEW = `
  mutation b2bOrderPreview($accountId: String!, $legalEntity: String, $cart: JSON! $invoiceDetails: JSON! $billingAddress: JSON! $shippingAddress: JSON!) {
    b2bOrderPreview(accountId: $accountId, legalEntity: $legalEntity, cart: $cart, invoiceDetails: $invoiceDetails, billingAddress: $billingAddress, shippingAddress: $shippingAddress)
  }
`;
exports.GET_ASSIGNED_ORDERS = `
  query getAssignedOrders($accountId: String!, $aicpaId: String!) {
    getAssignedOrders(accountId:$accountId, aicpaId:$aicpaId)
  }`;
exports.GET_ASSIGNED_APPLICATIONS = `
  query getAssignedApplications($personAccountId: String!) {
    getAssignedApplications(personAccountId: $personAccountId)
  }`;
exports.REMOVE_CLIENT_ADMIN = `
  mutation removeClientAdmin($accountId: String!, $adminToRemoveId: String!) {
    removeClientAdmin(accountId: $accountId, adminToRemoveId: $adminToRemoveId)
  }
`;
exports.REFUND = `
  mutation refund($zuoraPayload: [RefundZuoraPayload], $cancelAction: String, $taxAutoCalculation: Boolean) {
    refund(zuoraPayload: $zuoraPayload, cancelAction: $cancelAction, taxAutoCalculation: $taxAutoCalculation)
  }
`;
exports.CANCEL_AND_MOVE = `
  mutation cancelAndMovePayment($zuoraPayload: [MovePayment]) {
    cancelAndMovePayment(zuoraPayload: $zuoraPayload)
  }
`;
exports.CANCEL_MEMBERSHIP_ORDER = `
	mutation cancelMembershipOrder($zuoraPayload: [CancelMembershipOrder], $firmAccountId: String) {
		cancelMembershipOrder(zuoraPayload: $zuoraPayload, firmAccountId:  $firmAccountId)
	}
`;
exports.UPDATE_MEMBERSHIP_TERMINATION_STATUS = `
	mutation updateMembershipTerminationStatus($productSku: String!, $productType: String!, $productStatus: String!, $terminationReason: String!, $terminationComment: String, $ethicStatus: String) {
		updateMembershipTerminationStatus(productSku: $productSku, productType: $productType, productStatus: $productStatus, terminationReason: $terminationReason, terminationComment: $terminationComment, ethicStatus: $ethicStatus)
	}
`;
exports.GENERATE_BULK_RENEWAL_REPORT = `
  mutation generateBulkRenewalReport($membershipType: String!, $inBetweenDates: Boolean, $startDate: String, $endDate: String) {
    generateBulkRenewalReport(membershipType: $membershipType, inBetweenDates: $inBetweenDates, startDate: $startDate, endDate: $endDate) {
      id
      status
      action
    }
  }
`;
exports.GET_BULK_RENEWAL_TRANSACTION_HISTORY = `
  query getBulkRenewalTransactionHistory {
    getBulkRenewalTransactionHistory
  }
`;
exports.GET_RECENT_BULK_RENEWAL_TRANSACTION = `
  query getRecentBulkRenewalTransaction {
    getRecentBulkRenewalTransaction
  }
`;
exports.GET_RECENT_DOWNLOAD_REPORT = `
  query getRecentDownloadedReport {
    getRecentDownloadedReport {
      uniqueID
      date
      time
      generatedBy
      selections
    }
  }
`;
exports.DOWNLOAD_BULK_RENEWAL_REPORT = `
  mutation downloadBulkRenewalReport($uniqueID: String!) {
    downloadBulkRenewalReport(uniqueID: $uniqueID)
  }
`;
exports.PROCESS_BULK_RENEWAL = `
  mutation processBulkRenewalUpdateReport($id: String!, $action: String!) {
    processBulkRenewalUpdateReport(id: $id, action: $action) {
        id
        status
        action
    }
  }
  `;
exports.EXTEND_PRODUCT_ACCESS = `
mutation extendProductAccess($payload: [ProductExtensionB2CPayloadJSON]) {
  extendProductAccess(payload: $payload)
}
`;
exports.EXTENSION_RAISE_CREDIT_MEMO = `
mutation extensionRaiseCreditMemo($productSKU: String, $orderNumber: String){
  extensionRaiseCreditMemo(productSKU: $productSKU, orderNumber: $orderNumber)
}`;
exports.EXTEND_PRODUCT_ACCESS_B2B = `
  mutation extendProductAccessB2B($payload: [ProductExtensionB2BPayloadJSON]) {
    extendProductAccessB2B(payload: $payload)
  }
`;
exports.GET_RECENT_EXTENSION_PROCESS_STATUS = `
  query getRecentExtensionProcessStatus($serviceContractId: String) {
    getRecentExtensionProcessStatus(serviceContractId: $serviceContractId)
  }
`;
//# sourceMappingURL=admin-queries.js.map